import { memo, useCallback, useState } from 'react';
import PlayerTimelineButton from '../PlayerTimelineButton';
import { AddMenuPopover } from './';
import useEditorRestrictions from '@/hooks/useEditorRestrictions';

const AddMenuButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isAnyBlocked } = useEditorRestrictions();
  const isAddMenuBlocked = isAnyBlocked(['timeline-scene-add', 'timeline-chapters-edit']);

  const handleClick = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <PlayerTimelineButton
        tooltipTitle="Add at current time..."
        buttonId="timeline-add-menu-button"
        onClick={handleClick}
        iconName="IconPlus"
        isDisabled={isAddMenuBlocked}
      />
      {isOpen && <AddMenuPopover isOpen={isOpen} onClose={handleClose} />}
    </>
  );
};

export default memo(AddMenuButton);
